import {Controller} from "stimulus"

export default class extends Controller {
  static targets = ["result", "facility", "date", "timeBlock", "startTime", "endTime"]

  connect() {
    if (this.data.get("hourRange") === "true") {
      var date = this.hasDateTarget ? this.dateTarget.value : ""
      var facilityId = this.hasFacilityTarget ? this.facilityTarget.value : ""
      if (date && facilityId) {
        this._lastTimeOptionsKey = date + "|" + facilityId
        this.refreshTimeOptions(date)
      }
    }
  }

  checkAvailability() {
    var facilityId = this.facilityTarget.value
    var date = this.dateTarget.value
    var isHourRange = this.data.get("hourRange") === "true"

    if (isHourRange) {
      var timeOptionsKey = date + "|" + facilityId
      if (date && facilityId && timeOptionsKey !== this._lastTimeOptionsKey) {
        this._lastTimeOptionsKey = timeOptionsKey
        this.refreshTimeOptions(date)
      }
    }

    var bookingId = this.data.get("bookingId") || ""
    var url = this.data.get("url") +
      "?facility_id=" + encodeURIComponent(facilityId) +
      "&date=" + encodeURIComponent(date)

    if (bookingId) {
      url += "&booking_id=" + encodeURIComponent(bookingId)
    }

    if (isHourRange) {
      var startTime = this.hasStartTimeTarget ? this.startTimeTarget.value : ""
      var endTime = this.hasEndTimeTarget ? this.endTimeTarget.value : ""

      if (!facilityId || !date || !startTime || !endTime) {
        this.resultTarget.innerHTML = ""
        this.resultTarget.classList.add("hidden")
        return
      }

      url += "&start_time=" + encodeURIComponent(startTime) +
        "&end_time=" + encodeURIComponent(endTime)
    } else {
      var timeBlockKey = this.hasTimeBlockTarget ? this.timeBlockTarget.value : ""

      if (!facilityId || !date || !timeBlockKey) {
        this.resultTarget.innerHTML = ""
        this.resultTarget.classList.add("hidden")
        return
      }

      url += "&time_block_key=" + encodeURIComponent(timeBlockKey)
    }

    var self = this
    fetch(url, {
      headers: {"Accept": "application/json", "X-Requested-With": "XMLHttpRequest"}
    })
      .then(function(response) { return response.json() })
      .then(function(data) { self.renderResult(data) })
      .catch(function(err) {
        console.error("Slot check failed:", err)
        self.resultTarget.innerHTML = ""
        self.resultTarget.classList.add("hidden")
      })
  }

  refreshTimeOptions(date) {
    var timeOptionsUrl = this.data.get("timeOptionsUrl")
    if (!timeOptionsUrl || !date) return

    var facilityId = this.facilityTarget.value
    if (!facilityId) return

    var url = timeOptionsUrl + "?date=" + encodeURIComponent(date) +
      "&facility_id=" + encodeURIComponent(facilityId)
    var self = this

    fetch(url, {
      headers: {"Accept": "application/json", "X-Requested-With": "XMLHttpRequest"}
    })
      .then(function(response) { return response.json() })
      .then(function(data) {
        self.populateSelect(self.startTimeTarget, data.start_options)
        self.populateSelect(self.endTimeTarget, data.end_options)

        if ((!data.start_options || data.start_options.length === 0) &&
            (!data.end_options || data.end_options.length === 0)) {
          self.resultTarget.innerHTML =
            '<div class="rounded-md bg-amber-50 border border-amber-200 p-3">' +
              '<p class="text-sm text-amber-800">' +
                '<strong>&#9888; No Available Times</strong> — ' +
                'No time slots are available for the selected date. ' +
                'This date may be a blackout date or may not have scheduled hours. ' +
                'Please choose a different date.' +
              '</p>' +
            '</div>'
          self.resultTarget.classList.remove("hidden")
        } else {
          self.resultTarget.innerHTML = ""
          self.resultTarget.classList.add("hidden")
        }
      })
      .catch(function(err) {
        console.error("Time options refresh failed:", err)
      })
  }

  populateSelect(select, options) {
    if (!Array.isArray(options)) { options = [] }
    var currentValue = select.value
    var blankOption = select.querySelector("option[value='']")
    var blankText = blankOption ? blankOption.textContent : ""

    select.innerHTML = ""

    if (blankText) {
      var blank = document.createElement("option")
      blank.value = ""
      blank.textContent = blankText
      select.appendChild(blank)
    }

    for (var i = 0; i < options.length; i++) {
      var opt = document.createElement("option")
      opt.textContent = options[i][0]
      opt.value = options[i][1]
      if (options[i][1] === currentValue) {
        opt.selected = true
      }
      select.appendChild(opt)
    }
  }

  renderResult(data) {
    if (data.status === "available") {
      this.resultTarget.innerHTML =
        '<div class="rounded-md bg-green-50 border border-green-200 p-3">' +
          '<p class="text-sm text-green-800">' +
            '<strong>&#10003; Available</strong> — This slot is open.' +
          '</p>' +
        '</div>'
      this.resultTarget.classList.remove("hidden")
    } else if (data.status === "taken") {
      var slotDesc = this.escapeHtml(data.facility_name) +
        ' on ' + this.escapeHtml(data.date) +
        ' (' + this.escapeHtml(data.time_block) + ')'

      var html =
        '<div class="rounded-md bg-red-50 border border-red-200 p-3">' +
          '<p class="text-sm text-red-800">' +
            '<strong>&#10007; Slot Taken</strong> — ' +
            slotDesc + ' is already reserved by ' +
            this.escapeHtml(data.holder.applicant_name)

      if (data.holder.shortcode) {
        html += ' (' + this.escapeHtml(data.holder.shortcode) + ')'
      }
      html += '.</p>'

      if (data.alternatives && data.alternatives.length > 0) {
        html += '<p class="text-sm text-red-700 mt-2">' +
          '<strong>Available alternatives for ' + this.escapeHtml(data.date) +
          ' ' + this.escapeHtml(data.time_block) + ':</strong></p>' +
          '<ul class="mt-1 text-sm text-red-700 list-disc list-inside">'
        for (var i = 0; i < data.alternatives.length; i++) {
          html += '<li>' + this.escapeHtml(data.alternatives[i].name) + '</li>'
        }
        html += '</ul>'
      } else if (data.alternatives) {
        html += '<p class="text-sm text-red-700 mt-2">' +
          'No other facilities of this type are available for ' +
          this.escapeHtml(data.date) + ' ' + this.escapeHtml(data.time_block) + '.' +
          '</p>'
      }

      html += '</div>'
      this.resultTarget.innerHTML = html
      this.resultTarget.classList.remove("hidden")
    } else if (data.status === "blackout") {
      this.resultTarget.innerHTML =
        '<div class="rounded-md bg-amber-50 border border-amber-200 p-3">' +
          '<p class="text-sm text-amber-800">' +
            '<strong>&#9888; Blackout Date</strong> — ' +
            this.escapeHtml(data.message) +
          '</p>' +
        '</div>'
      this.resultTarget.classList.remove("hidden")
    } else if (data.status === "invalid_range") {
      this.resultTarget.innerHTML =
        '<div class="rounded-md bg-amber-50 border border-amber-200 p-3">' +
          '<p class="text-sm text-amber-800">' +
            '<strong>&#9888; Invalid Time Range</strong> — ' +
            this.escapeHtml(data.message) +
          '</p>' +
        '</div>'
      this.resultTarget.classList.remove("hidden")
    } else if (data.status === "unavailable_day") {
      this.resultTarget.innerHTML =
        '<div class="rounded-md bg-amber-50 border border-amber-200 p-3">' +
          '<p class="text-sm text-amber-800">' +
            '<strong>&#9888; Day Not Available</strong> — ' +
            this.escapeHtml(data.message) +
          '</p>' +
        '</div>'
      this.resultTarget.classList.remove("hidden")
    } else {
      this.resultTarget.innerHTML = ""
      this.resultTarget.classList.add("hidden")
    }
  }

  escapeHtml(text) {
    var div = document.createElement("div")
    div.appendChild(document.createTextNode(text))
    return div.innerHTML
  }
}
